import { Grid, Theme, useMediaQuery } from "@material-ui/core";
import { AgChartsReact } from "ag-charts-react";
import React from "react";
import { axes, chartTheme, getTitleConfig, series } from "./config";
import {
  EXPECTATIONS_CHART_TITLE,
  OVERALL_CHART_TITLE,
  WARMTH_CHART_TITLE,
} from "./constants";
import { ISurveyChartsProps } from "./types";

export const SurveyCharts = ({ chartPoints }: ISurveyChartsProps) => {
  const isDesktop = useMediaQuery(
    (theme: Theme) => `(min-width:${theme.breakpoints.values.md}px)`
  );

  const chartSettings = {
    axes,
    series,
    theme: chartTheme,
  };

  return (
    <>
      <div style={{ padding: isDesktop ? "0px 25%" : "0px" }}>
        <AgChartsReact
          options={{
            ...chartSettings,
            data: chartPoints?.overall,
            title: getTitleConfig(OVERALL_CHART_TITLE),
          }}
        />
      </div>
      <Grid container={true}>
        <Grid item={true} xs={12} md={6}>
          <AgChartsReact
            options={{
              ...chartSettings,
              data: chartPoints?.expectations,
              title: getTitleConfig(EXPECTATIONS_CHART_TITLE),
            }}
          />
        </Grid>
        <Grid item={true} xs={12} md={6}>
          <AgChartsReact
            options={{
              ...chartSettings,
              data: chartPoints?.warmth,
              title: getTitleConfig(WARMTH_CHART_TITLE),
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/features/director/pages/SurveyDataCenter/components/SurveyCharts/SurveyCharts.tsx